import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../_virtual/_rollupPluginBabelHelpers.js';

var loadLayouts = function loadLayouts(namespaceTags, getUserEntities, normalizeEntities) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(!namespaceTags.entityTag || !namespaceTags.groupTag)) {
            _context.next = 2;
            break;
          }
          throw new Error('entityTag and groupTag cannot be undefined.');
        case 2:
          _context.next = 4;
          return getUserEntities(namespaceTags.entityTag, namespaceTags.groupTag);
        case 4:
          response = _context.sent;
          return _context.abrupt("return", normalizeEntities(response));
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
};

export { loadLayouts };
//# sourceMappingURL=load-layouts.esm.js.map
